import cx from 'classnames';
import Styles from './mIndex.module.scss';

export interface IMoreActionIcon {
  className?: string;
  onClick: () => void;
}

const MoreActionIcon = ({
  className = '',
  onClick,
}: IMoreActionIcon) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <div className={cx(Styles.root, className)} onClick={handleClick}>
      <span className={Styles.circle} />
      <span className={Styles.circle} />
      <span className={Styles.circle} />
    </div>
  );
};

export default MoreActionIcon;
